export const ERROR_CODE = 200;
const apiUrl = process.env.REACT_APP_BACKEND_URL;

export const getAllDevicesIDs = async (devicesType, requestedParams, buildings_ids_list) => {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ requestedParams, buildings_ids_list }),
  };

  const res = await fetch(`${apiUrl}devices/${devicesType}`, requestOptions);

  return await res
    .json()
    .then(res => {
      return res;
    })
    .catch(err => {
      console.log(err);
      return ERROR_CODE;
    });
};

export const getAllControllers = async () => {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const res = await fetch(`${apiUrl}devices/Controllers`, requestOptions);

  return await res
    .json()
    .then(res => {
      return res;
    })
    .catch(err => {
      console.log(err);
      return ERROR_CODE;
    });
};

export const updateDevice = async deviceData => {
  const { deviceId, ...dataToSend } = deviceData;

  const requestOptions = {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(dataToSend),
  };

  const res = await fetch(`${apiUrl}devices/${deviceId}`, requestOptions); // deviceId in URL

  const data = await res.json();

  // Check for logical errors in the response
  if (!data.success) {
    throw new Error(data.message || 'Update failed');
  }

  return data;
};

export const deleteDevice = async deviceId => {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const res = await fetch(`${apiUrl}devices/delete/${deviceId}`, requestOptions);

  const data = await res.json();

  // Check for logical errors in the response
  if (!data.success) {
    throw new Error(data.message || 'Delete device failed');
  }

  return data;
};

export const deleteDeviceArea = async deviceId => {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const res = await fetch(`${apiUrl}devices/delete/area/${deviceId}`, requestOptions);

  const data = await res.json();

  // Check for logical errors in the response
  if (!data.success) {
    throw new Error(data.message || 'Delete area failed');
  }

  return data;
};

//not in use
export const saveSensorsFields = async (token, id, fieldsData) => {
  const requestOptions = {
    method: 'PUT',
    credentials: 'include',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id: id, data: fieldsData }),
  };

  const res = await fetch(`${apiUrl}devices/values/${id}`, requestOptions);

  return await res
    .json()
    .then(res => {
      return res;
    })
    .catch(err => {
      console.log(err);
      return ERROR_CODE;
    });
};

export const saveControllersFields = async (token, id, fieldsData) => {
  const requestOptions = {
    method: 'PUT',
    credentials: 'include',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id: id, data: fieldsData }),
  };

  const res = await fetch(`${apiUrl}devices/values/${id}`, requestOptions);

  return await res
    .json()
    .then(res => {
      return res;
    })
    .catch(err => {
      console.log(err);
      return ERROR_CODE;
    });
};
//not in use
export const addNewSensor = async (token, id, fieldsData) => {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id: id, data: fieldsData }),
  };

  const res = await fetch(`${apiUrl}devices/values/${id}`, requestOptions);

  return await res
    .json()
    .then(res => {
      return res;
    })
    .catch(err => {
      console.log(err);
      return ERROR_CODE;
    });
};

export const addNewController = async (token, id, fieldsData) => {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id: id, data: fieldsData }),
  };

  const res = await fetch(`${apiUrl}devices/values/${id}`, requestOptions);

  return await res
    .json()
    .then(res => {
      return res;
    })
    .catch(err => {
      console.log(err);
      return ERROR_CODE;
    });
};
//not in use
export const toDeleteSensor = async (token, id) => {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id: id }),
  };

  const res = await fetch(`${apiUrl}devices/delete/${id}`, requestOptions);

  return await res
    .json()
    .then(res => {
      return res;
    })
    .catch(err => {
      console.log(err);
      return ERROR_CODE;
    });
};

export const toDeleteController = async (token, id) => {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id: id }),
  };

  const res = await fetch(`${apiUrl}devices/delete/${id}`, requestOptions);

  return await res
    .json()
    .then(res => {
      return res;
    })
    .catch(err => {
      console.log(err);
      return ERROR_CODE;
    });
};

export const getDeviceValues = async (token, id) => {
  const requestOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const res = await fetch(`${apiUrl}devices/values/${id}`, requestOptions);

  return await res
    .json()
    .then(res => {
      return res;
    })
    .catch(err => {
      console.log(err);
      return ERROR_CODE;
    });

  // TODO: maybe transform result into a custom object with status, code, and value?
};

export const getAllDevicesFields = async token => {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };

  const res = await fetch(`${apiUrl}devices/fields`, requestOptions);

  return await res
    .json()
    .then(res => {
      return res;
    })
    .catch(err => {
      console.log(err);
      return ERROR_CODE;
    });

  // TODO: maybe transform result into a custom object with status, code, and value?
};

export const updateDevicesListReq = async () => {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const res = await fetch(`${apiUrl}devices/refresh`, requestOptions);

  return await res
    .json()
    .then(res => {
      return res;
    })
    .catch(err => {
      console.log(err);
      return ERROR_CODE;
    });

  // TODO: maybe transform result into a custom object with status, code, and value?
};
